import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import('../views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    meta: { title: '主页' },
    redirect: '/homework', // 蛇者重定向 进入 home页就默认进入homewrok
    refreshData: false,
    children: [
      {
        path: '/homework',
        name: 'Homework',
        component: () => import('../views/Homework/index.vue'),
        meta: {
          title: '学程列表',
          refreshData: true // 需要刷新数据
        },
      },
      {
        path: '/courseExplanation',
        name: 'CourseExplanation',
        component: () => import('../views/CourseExplanation/index.vue'),
        meta: {
          title: '学程讲解',
          refreshData: true // 需要刷新数据
        },
      },
    ]
  },
  {
    path: '/Knowledge',
    name: 'Knowledge',
    component: () => import('../views/Knowledge/index.vue'),
    meta: {
      title: '知识图谱',
      refreshData: true // 需要刷新数据
    },
  },
  {
    path: '/wrongtitlebook',
    name: 'wrongtitlebook',
    component: () => import('../views/wrongtitlebook/index.vue'),
    meta: {
      title: '错题重练',
      refreshData: true // 需要刷新数据
    },
  },
  {
    path: '/studentData',
    name: 'StudentData',
    component: () =>
      import('../views/StudentData/index.vue'),
    meta: {
      title: '学生数据',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/zuowenCourse',
    name: 'zuowenCourse',
    component: () =>
      import('../views/zuowenCourse/index.vue'),
    meta: {
      title: '作文课堂页面',
      refreshData: true
    }
  },
  {
    path: '/studyPlan',
    name: 'studyPlan',
    component: () =>
      import('../views/studyPlan/index.vue'),
    meta: {
      title: '学习规划页面',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/blineStudy',
    name: 'blineStudy',
    component: () =>
      import('../views/blineStudy/index.vue'),
    meta: {
      title: 'B线学习页面',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/reportV2',
    name: 'reportV2',
    component: () =>
      import('../views/ReportV2/index.vue'),
    meta: {
      title: '学习报告V2',
      refreshData: true
    }
  },
  {
    path: '/zuowenCompositionEvaluation',
    name: 'zuowenCompositionEvaluation',
    component: () =>
      import('../views/zuowenCourse/zuowenCompositionEvaluation.vue'),
    meta: {
      title: '作文课堂评价页面',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/typeWriting',
    name: 'TypeWriting',
    component: () =>
      import('../views/StudentData/typeWriting.vue'),
    meta: {
      title: '头脑风暴',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/studentProgram',
    name: 'studentProgram',
    component: () =>
      import('../views/studentProgram/index.vue'),
    meta: {
      title: '学生学程单',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/studentEvaluation',
    name: 'studentEvaluation',
    component: () =>
      import('../views/studentEvaluation/index.vue'),
    meta: {
      title: '学生学程单评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/compositionEvaluation',
    name: 'CompositionEvaluation',
    component: () =>
      import('../views/StudentData/compositionEvaluation.vue'),
    meta: {
      title: '作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/combinCompositionEvaluation',
    name: 'CombinCompositionEvaluation',
    component: () =>
      import('../views/StudentData/combinCompositionEvaluation.vue'),
    meta: {
      title: '组合作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/CompositionEvaluationGroup',
    name: 'CompositionEvaluationGroup',
    component: () =>
      import('../views/StudentData/compositionEvaluationGroup.vue'),
    meta: {
      title: '小组作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/ble',
    name: 'ble',
    component: () =>
      import('../views/BluetoothConfig/index.vue'),
    meta: {
      title: '蓝牙配网',
      refreshData: true // 需要刷新数据
    }
  },
  // 兜底：已删路由(如 courseList)或任意未知路径不再渲染空白壳，统一回首页
  {
    path: '*',
    redirect: '/homework',
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: '/zmTeach',
  routes,
});
// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.path == '/login') {
    next();
  } else {
    if (localStorage.getItem('zhimingUserTokenData')) {
      if (to.path == '/homework') { // 2026-08-24: 悬浮课件功能已移除, 原课件列表清除commit一并删除
        localStorage.removeItem('notify')
        localStorage.setItem('courseButton', true)
        localStorage.removeItem('NOteach')
        sessionStorage.clear()
      }
      next();
    } else {
      next('/login');
    }
  }
});
export default router;
